export type ReferralAction = 'set' | 'remove'

export const REFERRAL_ACTION_LABELS: Record<ReferralAction, string> = {
  set: 'Set Referral',
  remove: 'Remove Referral',
}

export const REFERRAL_ACTION_DESCRIPTIONS: Record<ReferralAction, string> = {
  set: 'Set or update a referral configuration',
  remove: 'Remove a referral by ID',
}
